import { render, staticRenderFns } from "./BroadcastMessageList.vue?vue&type=template&id=795a64b4&"
import script from "./BroadcastMessageList.vue?vue&type=script&lang=js&"
export * from "./BroadcastMessageList.vue?vue&type=script&lang=js&"
import style0 from "./BroadcastMessageList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports